<template>
    <step-choice
        tab-class="tab-code"
        headline="Haben Sie bereits einen Freischaltcode Ihrer Krankenkasse für Vitadio?"
        :options="options"
        @answer="$emit('answer', $event)"
    ></step-choice>
</template>

<script>
import StepChoice from './StepChoice'

export default {
    components: { StepChoice },

    data() {
        return {
            options: [
                { label: 'Ja', value: true, icon: 'yes' },
                { label: 'Nein', value: false, icon: 'no' }
            ]
        }
    }
}
</script>
